import * as React from "react";
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";

export const UploadModalFilesHeader: React.FC = () => (
  <TableHeader>
    <TableRow>
      <TableHead>File Name</TableHead>
      <TableHead>Size</TableHead>
      <TableHead>Type</TableHead>
      <TableHead>Status</TableHead>
      <TableHead>Progress</TableHead>
      <TableHead>Action</TableHead>
    </TableRow>
  </TableHeader>
);
